import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Users, HardHat, MapPin, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      y: 20,
      opacity: 0
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative w-full bg-[#2E78B6] text-white overflow-hidden" data-id="element-121">
      {/* Technical Grid Pattern Overlay */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-122" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-24" data-id="element-123">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-124">
          {/* Left Column: Text Content */}
          <motion.div variants={containerVariants} initial="hidden" animate="visible" className="max-w-2xl" data-id="element-125">
            <motion.div variants={itemVariants} className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-8 border border-white/20" data-id="element-126">
              <ShieldCheck className="w-5 h-5 text-[#F57C00]" data-id="element-127" />
              <span className="text-sm font-medium tracking-wide" data-id="element-128">
                Sinds 1977 uw partner in techniek
              </span>
            </motion.div>

            <motion.h1 variants={itemVariants} className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 tracking-tight" data-id="element-129">
              Uw betrouwbare partner in{' '}
              <span className="text-white border-b-4 border-[#F57C00]" data-id="element-130">
                infra- en elektrotechniek
              </span>
            </motion.h1>

            <motion.p variants={itemVariants} className="text-xl text-blue-50 mb-8 font-light leading-relaxed" data-id="element-131">
              Sinds 1977 ondersteunen wij grote installateurs bij complexe
              projecten in industrie, utiliteit en openbare infrastructuur.
            </motion.p>

            <motion.p variants={itemVariants} className="text-lg text-blue-100 mb-10" data-id="element-132">
              Wij leveren capaciteit, vakmanschap en technische zekerheid —
              precies wanneer uw project dat vraagt.
            </motion.p>

            <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-133">
              <Button className="bg-[#F57C00] hover:bg-[#E56A00] text-white px-8 py-4 rounded-lg font-bold text-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-134">
                Neem contact op
              </Button>
              <Button className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#2E78B6] px-8 py-4 rounded-lg font-bold text-lg transition-all flex items-center justify-center gap-2" data-id="element-135">
                <Phone className="w-5 h-5" data-id="element-136" />
                Bel direct +31 (0) 72 5626656
              </Button>
            </motion.div>
          </motion.div>

          {/* Right Column: Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="relative hidden lg:block h-full min-h-[500px]" data-id="element-137">
            <div className="absolute inset-0 bg-[#F57C00] rounded-2xl transform rotate-3 translate-x-4 translate-y-4 opacity-20" data-id="element-138"></div>
            <div className="relative h-full rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10" data-id="element-139">
              <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80" alt="Industrial infrastructure work" className="w-full h-full object-cover" data-id="element-140" />

              {/* Floating Stats Card */}
              <div className="absolute bottom-8 left-8 bg-white/95 backdrop-blur-md p-6 rounded-xl shadow-lg max-w-xs border-l-4 border-[#F57C00]" data-id="element-141">
                <div className="flex items-center gap-4 mb-2" data-id="element-142">
                  <div className="p-2 bg-blue-50 rounded-lg" data-id="element-143">
                    <Users className="w-6 h-6 text-[#2E78B6]" data-id="element-144" />
                  </div>
                  <div data-id="element-145">
                    <p className="text-sm text-gray-500 font-medium" data-id="element-146">
                      Capaciteit
                    </p>
                    <p className="text-xl font-bold text-gray-900" data-id="element-147">
                      25-30 Specialisten
                    </p>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mt-2" data-id="element-148">
                  Direct inzetbaar voor uw projecten.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* USP Bar - Full Width below columns */}
        <motion.div variants={itemVariants} initial="hidden" animate="visible" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 pt-12 border-t border-white/20 mt-8" data-id="element-149">
          <div className="flex items-center gap-3" data-id="element-150">
            <div className="p-2 bg-white/10 rounded-lg" data-id="element-151">
              <ShieldCheck className="w-6 h-6 text-[#F57C00]" data-id="element-152" />
            </div>
            <span className="font-medium" data-id="element-153">45+ jaar ervaring</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-154">
            <div className="p-2 bg-white/10 rounded-lg" data-id="element-155">
              <Users className="w-6 h-6 text-[#F57C00]" data-id="element-156" />
            </div>
            <span className="font-medium" data-id="element-157">25–30 vakmensen</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-158">
            <div className="p-2 bg-white/10 rounded-lg" data-id="element-159">
              <HardHat className="w-6 h-6 text-[#F57C00]" data-id="element-160" />
            </div>
            <span className="font-medium" data-id="element-161">VCA**, BRL 6000 & ISO</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-162">
            <div className="p-2 bg-white/10 rounded-lg" data-id="element-163">
              <MapPin className="w-6 h-6 text-[#F57C00]" data-id="element-164" />
            </div>
            <span className="font-medium" data-id="element-165">Landelijk inzetbaar</span>
          </div>
        </motion.div>
      </div>
    </section>;
}